import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { focusRing } from "../foundations/focus";

const baseStyle = defineStyle({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  borderRadius: "md",
  fontWeight: "normal",
  letterSpacing: "button",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  lineHeight: 1,
  transitionProperty: "background-color, color, transform",
  transitionDuration: "0.25s",
  transitionTimingFunction: "brand",
  _active: { transform: "translateY(1px)" },
  _focusVisible: focusRing,
});

const sizes = {
  brand: defineStyle({
    minH: "60px",
    h: "auto",
    minW: "auto",
    px: "28px",
    py: "16px",
    fontSize: "button",
  }),
  nav: defineStyle({
    minH: "46px",
    h: "auto",
    minW: "auto",
    px: "20px",
    fontSize: "0.875rem",
  }),
};

const variants = {
  solid: defineStyle({
    bg: "surface.white",
    color: "ink.DEFAULT",
    _hover: { bg: "brand.600", color: "ink.light" },
  }),
  brand: defineStyle({
    bg: "brand.600",
    color: "ink.light",
    _hover: { bg: "ink.DEFAULT", color: "ink.light" },
  }),
  ghost: defineStyle({
    bg: "transparent",
    color: "ink.DEFAULT",
    border: "1px solid",
    borderColor: "line.hairline",
    _hover: { bg: "brand.600", color: "ink.light", borderColor: "brand.600" },
  }),
  outline: defineStyle({
    bg: "transparent",
    color: "ink.light",
    border: "1px solid",
    borderColor: "line.glassBorder",
    _hover: { bg: "brand.600", color: "ink.light", borderColor: "brand.600" },
  }),
};

export const Button = defineStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: { variant: "solid", size: "brand" },
});
